import {
  MantineSize,
  MenuItemProps,
  Menu,
  ActionIcon,
  rem,
  MenuProps,
} from "@mantine/core"
import { IconDotsVertical } from "@tabler/icons-react"

export interface DottedMenuProps extends MenuProps {
  size?: MantineSize
  items: ((MenuItemProps & React.DOMAttributes<HTMLButtonElement>) | null)[]
}

export function DottedMenu({ items, size, ...props }: DottedMenuProps) {
  return (
    <Menu withinPortal position="bottom-end" shadow="sm" {...props}>
      <Menu.Target>
        <ActionIcon
          variant="subtle"
          disabled={props.disabled}
          color="gray"
          size={size}
          onClick={(e) => {
            e.stopPropagation()
            e.preventDefault()
          }}
        >
          <IconDotsVertical style={{ width: rem(16), height: rem(16) }} />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        {items.map((props, i) =>
          props ? (
            <Menu.Item
              key={i}
              onClick={(e) => {
                e.bubbles = false
                e.preventDefault()
              }}
              {...props}
            />
          ) : null
        )}
      </Menu.Dropdown>
    </Menu>
  )
}
